/* eslint-disable import/no-unresolved */
import React from 'react';

import RightModalLayout from '../../../../../../../../layouts/Modal/RightModalLayout';
import ToggleSwitchMC from '../../../../../../../../components/ToggleSwitchMC';

const RetrieveProductsToolView = ({
  t,
  footerSubmitLabel,
  handleBack,
  handleConfirmRetrieveProducts,
  retrieveProductsIncludeImages,
  setRetrieveProductsIncludeImages
}) => (
  <RightModalLayout
    closeAction={handleBack}
    title={t('tools.retrieve_products_title')}
    showBackButton
    submitLabel={footerSubmitLabel}
    submitAction={handleConfirmRetrieveProducts}
    cancelLabel={t('Common:actions.cancel')}
    cancelAction={handleBack}
    footerVariant="VERTICAL"
  >
    <div className="tw-flex tw-flex-col tw-gap-6">
      <div>
        <div className="tw-font-bold tw-text-gray-900 tw-text-sm tw-mb-1">
          {t('tools.retrieve_products_title')}
        </div>
        <div className="tw-text-gray-600 tw-text-xs">
          {t('tools.retrieve_products_include_images_description')}
        </div>
      </div>
      <ToggleSwitchMC
        isOn={retrieveProductsIncludeImages}
        handleToggle={setRetrieveProductsIncludeImages}
        label={t('tools.retrieve_products_include_images_toggle')}
        labelClassName="!tw-font-semibold"
        size="medium"
      />
    </div>
  </RightModalLayout>
);

export default RetrieveProductsToolView;
